import { Observable } from 'rxjs/internal/Observable';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { BehaviorSubject } from 'rxjs/internal/BehaviorSubject';
import { ApiBuilderService } from '@shared/services/api-builder.service';
import { HsCodeResponseData } from '@shared/model/hscode-response.model';
import { TransPortTypeResponseData } from '@shared/model/transportType-response.model';
import { IncotermsIdResponseData } from '@shared/model/incoterms-id-response.model';
import { ContainerLoadTypeResponseDataModel } from '@shared/model/container-load-type-response.model';
import { QuoteRequestResponse, QuoteRequestResponseData } from '@shared/model/qoute-request-response.model';
import { PortTypeModel } from '@shared/model/port-type.model';
import { CountriesResponseModel, CountriesResponseModelData } from '@shared/model/countries-list-response.model';

const route = '/api/v1/base-info';

@Injectable({
  providedIn: 'root',
})

export class BaseInfoService {


  constructor(public http: HttpClient,
              private apiBuilder: ApiBuilderService,) {
  }
  getHsCode(isText: boolean, data: string): Observable<HsCodeResponseData[]> {
    if (isText) {
      return this.apiBuilder.get<HsCodeResponseData[]>(`${route}/hscode?text=${data}`).pipe(
        map((res: any) => res.data)
      );
    }
    return this.apiBuilder.get<HsCodeResponseData[]>(`${route}/hscode?hscode=${data}`).pipe(
      map((res: any) => res.data)
    );
  }
  public getTransportType(): Observable<TransPortTypeResponseData[]> {
    return this.apiBuilder.get<TransPortTypeResponseData[]>(`${route}/transport-type`).pipe(
      map((res: any) => res.data)
    );
  }
  public getIncotermsId(incotermsId?: number): Observable<IncotermsIdResponseData> {
    const params ={id: incotermsId};
    return this.apiBuilder.get<IncotermsIdResponseData>(`${route}/incoterms`, params).pipe(
      map((res: any) => res.data)
    );
  }
  public getIncoterms(): Observable<IncotermsIdResponseData> {
    return this.apiBuilder.get<IncotermsIdResponseData>(`${route}/incoterms`).pipe(
      map((res: any) => res.data)
    );
  }

  public getContainerLoadType(): Observable<ContainerLoadTypeResponseDataModel[]> {
    return  this.apiBuilder.get<ContainerLoadTypeResponseDataModel[]>(`${route}/container-load-type`).pipe(
      map((res: any) => res.data)
    );
  }
  public getQuoteRequest(): Observable<QuoteRequestResponseData> {
    return this.apiBuilder.get(`${route}/quote-request`).pipe(
        map((res: QuoteRequestResponse) => {
          this.$userQuoteRequest.next(res.data);
          return res.data;
        })
      );
  }

  public portType(): Observable<PortTypeModel[]> {
    return this.apiBuilder.get<PortTypeModel[]>(`${route}/port/type`).pipe(
      map((res: any) => res.data)
    );
  }
 
  public getStatesCounty(countryId: number): Observable<CountriesResponseModel> {
    return this.apiBuilder.get<CountriesResponseModel>(`${route}/country/${countryId}`).pipe(
      map((res: any) => res.data)
    );
  }
  public getStateSearch(textFilter: string): Observable<CountriesResponseModel> {
    const params ={data: textFilter};
    return this.apiBuilder.get<CountriesResponseModel>(`${route}/states`, params).pipe(
      map((res: any) => res.data)
    );
  }
  public getCity(stateId: number): Observable<CountriesResponseModel> {
    return this.apiBuilder.get<CountriesResponseModel>(`${route}/state/${stateId}`).pipe(
      map((res: any) => res.data)
    );
  }
  public getCityList(countryId: number, txt: string): Observable<CountriesResponseModelData[]>{
    const params ={data: txt, startPage: 1 , pageSize: 250};
    return this.apiBuilder.get(`${route}/country/city/${countryId}`,params).pipe(map(
      (res: CountriesResponseModel) => res.data
    ));
  }
  public getCityForState(textFilter: string): Observable<CountriesResponseModel> {
    const params ={data: textFilter};
    return this.apiBuilder.get<CountriesResponseModel>(`${route}/states`, params).pipe(
      map((res: any) => res.data)
    );
  }
  public $userQuoteRequest: BehaviorSubject<QuoteRequestResponseData> =
    new BehaviorSubject<QuoteRequestResponseData>(
      {} as QuoteRequestResponseData
  );

  getAlphabet(countryCode: string): Observable<any[]>  {
    return this.apiBuilder.get( `${route}/plaque/alphabet?countryCode=${countryCode}` ).pipe(
      map((res: any) => res.data)
    );
  }
  public getColor(textFilter: string): Observable<any[]>{
    return this.apiBuilder.get(`${route}/car/color?data=${textFilter}`).pipe(map(
      (res: any) => res.data
    ));
  }

  getTransportationFleet(){
    return this.apiBuilder.get( `${route}/transportation/fleet` ).pipe(
      map((res: any) => res.data)
    );
  }

  getDocFileCmr(){
    return this.apiBuilder.get( `${route}/cmr/docfile` ).pipe(
      map((res: any) => res.data)
    );
  }
  getPaymentStructure(){
    return this.apiBuilder.get( `${route}/cmr/payment/structure` ).pipe(
      map((res: any) => res.data)
    );
  }

  getCurrencies(){
    return this.apiBuilder.get( `${route}/currencies` ).pipe(
      map((res: any) => res.data)
    );
  }
  getUnpredictables(){
    return this.apiBuilder.get( `${route}/unpredictables` ).pipe(
      map((res: any) => res.data)
    );
  }

  getFeedBackTitle(){
    return this.apiBuilder.get( `${route}/feedback` ).pipe(
      map((res: any) => res.data)
    );
  }
  public getCountryList(textFilter: string): Observable<CountriesResponseModelData[]>{
    const params ={data: textFilter, startPage: 1 , pageSize: 250};
    return this.apiBuilder.get(`${route}/countries`, params).pipe(map(
      (res: CountriesResponseModel) => res.data
    ));
  }

  getFileTitleQuote(){
    return this.apiBuilder.get(`${route}/file/quote/title` ).pipe(
      map((res: any) => res.data)
    );
  }

}
